<div class="min-h-screen bg-gray-50 p-6 pt-24">
  <div class="max-w-6xl mx-auto flex flex-col gap-5">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 px-5 py-4">
      <div class="flex items-center gap-3">
        <i class="pi pi-cog text-blue-600 text-2xl flex-shrink-0"></i>
        <h1 class="text-2xl font-semibold text-gray-800">Configuración del Agente</h1>
      </div>
      <p class="text-sm text-gray-400 ml-9">Configuración de la cuenta y sus integraciones.</p>
    </div>

    <form #agentConfigForm="ngForm" (ngSubmit)="sendAgentConfig()" class="flex flex-col gap-5">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <section class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center gap-2 mb-5">
          <i class="pi pi-building text-blue-600"></i>
          <h2 class="text-base font-semibold text-gray-800">Cuenta</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label for="accountName" class="block text-sm font-semibold text-gray-700 mb-2">Nombre</label>
            <input id="accountName" name="accountName" pInputText [(ngModel)]="agentConfig.accountName" class="w-full" placeholder="Nombre de la cuenta" required />
          </div>
          <div>
            <label for="accountId" class="block text-sm font-semibold text-gray-700 mb-2">Account ID</label>
            <input id="accountId" name="accountId" pInputText [(ngModel)]="agentConfig.accountId" class="w-full font-mono text-sm" placeholder="UUID de la cuenta" required />
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center gap-2 mb-5">
          <i class="pi pi-shop text-green-600"></i>
          <h2 class="text-base font-semibold text-gray-800">MobyDyg</h2>
          <span class="ml-auto text-xs font-mono text-gray-400">mobydyg</span>
        </div>
        <div>
          <label for="mobydygShopId" class="block text-sm font-semibold text-gray-700 mb-2">Shop ID</label>
          <input id="mobydygShopId" name="mobydygShopId" pInputText type="number" [(ngModel)]="agentConfig.mobydygShopId" class="w-full" placeholder="ID de la tienda" required />
        </div>
      </section>

      <section class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center gap-2 mb-5">
          <i class="pi pi-send text-purple-600"></i>
          <h2 class="text-base font-semibold text-gray-800">Infobip</h2>
          <span class="ml-auto text-xs font-mono text-gray-400">infobip</span>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2">
            <label for="infobipApiKey" class="block text-sm font-semibold text-gray-700 mb-2">API Key</label>
            <input id="infobipApiKey" name="infobipApiKey" pInputText type="password" [(ngModel)]="agentConfig.infobipApiKey" class="w-full" placeholder="Ingrese la API Key" autocomplete="new-password" required />
          </div>
          <div>
            <label for="infobipBaseUrl" class="block text-sm font-semibold text-gray-700 mb-2">Base URL</label>
            <input id="infobipBaseUrl" name="infobipBaseUrl" pInputText [(ngModel)]="agentConfig.infobipBaseUrl" class="w-full" placeholder="URL base de Infobip" required />
          </div>
          <div>
            <label for="infobipSender" class="block text-sm font-semibold text-gray-700 mb-2">Sender</label>
            <input id="infobipSender" name="infobipSender" pInputText [(ngModel)]="agentConfig.infobipSender" class="w-full" placeholder="Sender de Infobip" />
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center gap-2 mb-5">
          <i class="pi pi-comments text-orange-500"></i>
          <h2 class="text-base font-semibold text-gray-800">Chatwoot</h2>
          <span class="ml-auto text-xs font-mono text-gray-400">chatwoot</span>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2">
            <label for="chatwootBaseUrl" class="block text-sm font-semibold text-gray-700 mb-2">Base URL</label>
            <input id="chatwootBaseUrl" name="chatwootBaseUrl" pInputText [(ngModel)]="agentConfig.chatwootBaseUrl" class="w-full" placeholder="URL de Chatwoot" required />
          </div>
          <div>
            <label for="chatwootApiKey" class="block text-sm font-semibold text-gray-700 mb-2">API Key</label>
            <input id="chatwootApiKey" name="chatwootApiKey" pInputText type="password" [(ngModel)]="agentConfig.chatwootApiKey" class="w-full" placeholder="Ingrese la API Key" autocomplete="new-password" required />
          </div>
          <div>
            <label for="chatwootAccountId" class="block text-sm font-semibold text-gray-700 mb-2">Account ID</label>
            <input id="chatwootAccountId" name="chatwootAccountId" pInputText type="number" [(ngModel)]="agentConfig.chatwootAccountId" class="w-full" placeholder="ID de la cuenta" required />
          </div>
        </div>
      </section>
    </div>
    <div class="flex justify-end">
      <button pButton type="submit" label="Guardar configuración" icon="pi pi-save"
        class="p-button-success" [disabled]="agentConfigForm.invalid"></button>
    </div>
    </form>

    <section class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <div class="flex items-center gap-3 mb-5">
        <i class="pi pi-share-alt text-blue-600 text-xl"></i>
        <div class="flex-1">
          <h2 class="text-base font-semibold text-gray-800">Canales</h2>
          <p class="text-sm text-gray-400 mt-0.5">Canales de mensajería asociados a cada cuenta.</p>
        </div>
        <button pButton type="button" label="Crear canal" icon="pi pi-plus"
          class="p-button-success p-button-sm" (click)="openChannelDialog()"></button>
      </div>

      <p-table [value]="channels" responsiveLayout="scroll" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Cuenta</th>
            <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Canal</th>
            <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Número / ID</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-channel>
          <tr class="border-b border-gray-100 hover:bg-gray-50">
            <td class="p-4 text-gray-700 text-sm">{{ channel.accountName }}</td>
            <td class="p-4 text-gray-700 text-sm capitalize">{{ channel.channelType }}</td>
            <td class="p-4 text-gray-700 text-sm">{{ channel.channelValue }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center p-10 text-gray-400">
              <i class="pi pi-inbox text-4xl mb-3 block text-gray-300"></i>
              No hay canales creados todavía.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </div>
</div>

<p-toast></p-toast>

<p-dialog
  [(visible)]="showChannelDialog"
  header="Crear canal"
  [modal]="true"
  [style]="{ width: '30vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }">

  <div class="flex flex-col gap-4">
    <div>
      <label for="channelAccount" class="block mb-2 font-semibold text-gray-700">Cuenta</label>
      <p-select
        inputId="channelAccount"
        [options]="accounts"
        [(ngModel)]="newChannel.accountId"
        optionLabel="name"
        optionValue="accountId"
        [loading]="accountsLoading"
        placeholder="Seleccione una cuenta"
        appendTo="body"
        class="w-full">
      </p-select>
    </div>

    <div>
      <label for="channelType" class="block mb-2 font-semibold text-gray-700">Canal</label>
      <p-select
        inputId="channelType"
        [options]="channelTypeOptions"
        [(ngModel)]="newChannel.channelType"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un canal"
        appendTo="body"
        class="w-full">
      </p-select>
    </div>

    <div>
      <label for="channelValue" class="block mb-2 font-semibold text-gray-700">Número / ID</label>
      <input id="channelValue" pInputText [(ngModel)]="newChannel.channelValue" class="w-full"
        placeholder="Ej: +506 8888 8888" />
    </div>
  </div>

  <div class="flex justify-end gap-2 pt-4 mt-4 border-t border-gray-200">
    <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="closeChannelDialog()"></button>
    <button pButton type="button" label="Crear" icon="pi pi-check" class="p-button-success"
      [disabled]="!newChannel.accountId || !newChannel.channelType || !newChannel.channelValue"
      (click)="createChannel()"></button>
  </div>
</p-dialog>
